(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-mybets-wager/assets/javascripts/api-calls/wager.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-mybets-wager/assets/javascripts/api-calls/wager.js');

'use strict';

const trinidadCore = svs.isServer ? require('@svenskaspelab/trinidad-core').core : null;
const logger = svs.isServer ? trinidadCore.core.logger('module:lyckoplatsen') : svs.lyckoplatsen.logger;
const drawgamesApiCaller = svs.isServer ? trinidadCore.components.require('tur', 'api-caller').drawgamesApiCaller : svs.tur.apiCaller.drawgames;
async function fetchWagerById(wagerId, req) {
  try {
    const result = await drawgamesApiCaller.getPlayerWagerById({
      wagerId,
      req
    });
    return result;
  } catch (error) {
    logger.error("Failed to get wager by id", error);
  }
}
if (svs.isServer) {
  module.exports = {
    fetchWagerById
  };
} else {
  setGlobal('svs.lyckoplatsen.components.shared_mybets_wager.api_calls', {
    fetchWagerById
  });
}

 })(window);